'use client'

import { isEmpty } from 'lodash'
import { Calendar } from 'react-feather'
import { useTranslations } from '@/lib/next-shim'

import { useListPrioritizedMeetingLinksQuery } from '@/core/graphql/hooks'
import Container from '@/components/ui/layouts/Container'

import PrioritizedMeetingLinks from './PrioritizedMeetingLinks'

export default function MeetingLinks() {
  const t = useTranslations('marketing.sections.MeetingLinks')

  const { data, loading } = useListPrioritizedMeetingLinksQuery()

  // Always render the section so it stays a reachable scroll target for the "Book Now"
  // CTAs — even with no proposed links (in which case we show an empty state instead of
  // returning null, which would make the anchor a no-op). `scroll-mt` offsets the sticky header.
  const isEmptyList = !loading && isEmpty(data?.prioritizedMeetingLinks)

  return (
    <section id="meeting-links" data-section="meeting-links" className="bg-white flex flex-col w-full scroll-mt-24">
      {isEmptyList ? (
        <Container className="my-5 w-full">
          <div className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-gray-50/60 px-6 py-12 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Calendar size={24} aria-hidden="true" />
            </div>
            <h3 className="text-base font-semibold text-gray-900">{t('emptyTitle')}</h3>
            <p className="max-w-sm text-sm text-gray-500">{t('empty')}</p>
          </div>
        </Container>
      ) : (
        <>
          <Container className="my-5 flex flex-row items-center w-full">
            <h2 className="text-lg max-lg:text-center font-semibold leading-8 text-gray-900">{t('title')}</h2>
          </Container>
          <Container className="my-5 w-full">
            <PrioritizedMeetingLinks />
          </Container>
        </>
      )}
    </section>
  )
}
